import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initInterpreteSlice,
  setPropertiesInterprete,
  updateInterprete,
} from "../Slices/InterpreteSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  roles,
} from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { DownOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { AiFillCalendar } from "react-icons/ai";
import { FaExternalLinkAlt } from "react-icons/fa";
import { t } from "i18next";
import { CiMail } from "react-icons/ci";
import { RiMailSendLine } from "react-icons/ri";

const { Content, Sider, Header, Footer } = Layout;

export function InterpreteDetail({ unitId, expanded, onClose }) {
  const { t } = useTranslation();
  const { id } = useParams();
  const { interprete, loading } = useSelector(state => state.interprete);

  const { configuration } = useContext(UserContext);

  const { user } = useContext(UserContext);

  const { init, clear } = initInterpreteSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {
    info: {
      firstname,
      lastname,
      genre,
      etatCivil,
      phone,
      nationality,
      birthday,
      country,
      children,
    },
    status,
    interpreteData: {
      urgentListAllowed = false,
      abacusId,
      iban,
      bankingName,
      bankingHead,
      contractStartDate = null,
      avs = "",
      institutionsToAvoid,
      dateWeddingDivorce = null,
      lastDateFormation,
      partnerIndemnity,
      sharedFolder = "",
      addressStart,
      address,
      licence,
      taxeSource,
      languages,
      number,
      expirationDateLicence,
      lastDateControl,
    },
    comment,
    email,
    subRoles,
  } = interprete;

  const inputs = [
    {
      parentLabel: t("InterpreteDetail.informations"),
      children: [
        {
          label: t("InterpreteDetail.name"),
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: t("InterpreteDetail.firstname"),
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.interpreteNumber"),
          name: "interpreteData.abacusId",
          value: abacusId,
          placeholder: t("InterpreteDetail.interpreteNumberAbacus"),
          type: "number",
          precision: 0,
          min: 0,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: t("InterpreteDetail.genre"),
          name: "info.genre",
          placeholder: t("InterpreteDetail.genre"),
          value: genre ? genre : undefined,
          required: true,
          type: "select",
          selectContent: [
            { label: t("InterpreteDetail.male"), value: "male" },
            { label: t("InterpreteDetail.female"), value: "female" },
          ],
          col: 24,
        },
        {
          label: t("InterpreteDetail.etatCivil"),
          name: "info.etatCivil",
          placeholder: t("InterpreteDetail.etatCivil"),
          value: etatCivil,
          // required: true,
          type: "select",
          selectContent: [
            { label: t("InterpreteDetail.single"), value: "single" },
            { label: t("InterpreteDetail.married"), value: "married" },
            { label: t("InterpreteDetail.divorced"), value: "divorced" },
            { label: t("InterpreteDetail.widowed"), value: "widowed" },
            {
              label: t("InterpreteDetail.registeredPartnership"),
              value: "registeredPartnership",
            },
            {
              label: t("InterpreteDetail.dissolvedPartnership"),
              value: "dissolvedPartnership",
            },
          ],
          col: 24,
        },
        {
          name: "info.dateWeddingDivorce",
          label: t("InterpreteDetail.dateWeddingDivorce"),
          value: dateWeddingDivorce ? dayjs(dateWeddingDivorce) : null,
          col: 24,
          type: "date",
        },
        {
          label: t("InterpreteDetail.email"),
          name: "email",
          normalize: value => value && value.toLowerCase(),
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: t("InterpreteDetail.phone"),
          name: "info.phone",
          value: phone,
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 24,
        },

        {
          required: true,
          label: t("InterpreteDetail.addressStart"),
          name: "interpreteData.addressStart",
          value: addressStart,
          type: "google-adress",
          col: 24,
        },

        {
          label: t("InterpreteDetail.comment"),
          name: "comment",
          value: comment,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          type: "textarea",
          col: 24,
        },
        {
          addonBefore: <FaExternalLinkAlt />,
          label: t("InterpreteDetail.shared"),
          name: "interpreteData.sharedFolder",
          visible:
            userHasLevel({
              not: {
                [roles.interprete]: "r", //
              },
            }) && configuration?.interprete?.hasInputSharedFolder,
          value: sharedFolder,
          type: "input-link",
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("InterpreteDetail.linguistique"),
      children: [
        {
          label: t("InterpreteDetail.languages"),
          name: "interpreteData.languages",
          value: languages,
          multiple: true,
          showSearch: true,
          type: "select",
          selectContent: languagesList().sort((a, b) =>
            a?.label?.localeCompare(b.label),
          ),
          col: 24,
        },
        {
          label: t("InterpreteDetail.interpretingMode"),
          required: true,
          name: "interpreteData.interpretingMode",
          type: "checkbox",
          value: interprete.interpreteData.interpretingMode,
          checkboxs: modeInterpretariat(),
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("InterpreteDetail.trainings"),
      children: [
        {
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          label: t("InterpreteDetail.trainings"),
          name: "interpreteData.formations",
          type: "input",
          capitalize: false,
          col: 24,
        },
        {
          label: t("InterpreteDetail.diplomas"),
          name: "interpreteData.diplomas",
          type: "radios",
          radios: diplomas(),
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: t("InterpreteDetail.level"),
          name: "interpreteData.level",
          type: "radios",
          visible: configuration?.interprete?.hasLevel,
          radios: levels(),
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: t("InterpreteDetail.lastTrainingDate"),
          name: "interpreteData.lastDateFormation",
          value: lastDateFormation ? dayjs(lastDateFormation) : null,
          type: "date",
          allowClear: true,
          showTime: false,
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("InterpreteDetail.admin"),
      children: [
        {
          label: t("InterpreteDetail.nationality"),
          name: "info.nationality",
          value: nationality,
          placeholder: t("InterpreteDetail.nationality"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.country"),
          name: "info.country",
          value: country,
          placeholder: t("InterpreteDetail.country"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.birthday"),
          name: "interpreteData.birthday",
          value: birthday,
          defaultValue: birthday ? dayjs(birthday) : null,
          placeholder: t("InterpreteDetail.birthday"),
          type: "date",
          col: 24,
        },
        {
          label: t("InterpreteDetail.avs"),
          name: "interpreteData.avs",
          value: avs,
          placeholder: t("InterpreteDetail.avs"),
          type: "input",
          col: 24,
        },

        {
          label: t("InterpreteDetail.partnerIndemnity"),
          name: "interpreteData.partnerIndemnity",
          value: partnerIndemnity,
          placeholder: t("InterpreteDetail.partnerIndemnity"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.licence"),
          name: "interpreteData.licence",
          value: licence,
          placeholder: t("InterpreteDetail.licence"),
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.taxeSource"),
          name: "interpreteData.taxeSource",
          value: taxeSource,
          placeholder: t("InterpreteDetail.taxeSource"),
          type: "checkbox-bool",
          col: 24,
        },
        {
          label: t("InterpreteDetail.expirationDateLicence"),
          name: "interpreteData.expirationDateLicence",
          allowClear: true,
          value: expirationDateLicence ? dayjs(expirationDateLicence) : null,
          placeholder: t("InterpreteDetail.expirationDateLicence"),
          type: "date",
          col: 24,
        },
        {
          label: t("InterpreteDetail.children"),
          name: "info.children",
          value: children,
          type: "input",
          col: 24,
        },
        {
          label: t("InterpreteDetail.authorisation"),
          name: "interpreteData.urgentListAllowed",
          type: "checkbox-bool",
          value: urgentListAllowed,
          col: 24,
        },
        {
          label: t("InterpreteDetail.contractStartDate"),
          name: "interpreteData.contractStartDate",
          type: "date",
          value: contractStartDate ? dayjs(contractStartDate) : null,
          col: 24,
        },
        {
          label: t("InterpreteDetail.iban"),
          name: "interpreteData.iban",
          type: "input",
          value: iban,
          col: 24,
        },
        {
          label: t("InterpreteDetail.bankingName"),
          name: "interpreteData.bankingName",
          type: "input",
          value: bankingName,
          col: 24,
        },
        {
          label: t("InterpreteDetail.bankingHead"),
          name: "interpreteData.bankingHead",
          type: "input",
          value: bankingHead,
          col: 24,
        },
      ],
    },
    {
      parentLabel: userHasLevel({
        not: {
          [roles.interprete]: "r", //
        },
      })
        ? t("InterpreteDetail.actions")
        : "",
      children: [
        loading !== true
          ? {
              label: t("InterpreteDetail.avoidClients"),
              name: "interpreteData.institutionsToAvoid",
              type: "dynamic-select",
              value: institutionsToAvoid,
              visible: userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              endPoint: "institutions",
              multiple: true,
              itemsCallBack: (institutions, form) => {
                try {
                  setReady(true);
                  formRef.current.setFieldValue(
                    "interpreteData.institutionsToAvoid",
                    institutionsToAvoid,
                  );
                } catch (e) {
                  console.log(e);
                }
              },
              itemCallback: item => {
                return {
                  key: item._id,
                  label: `${item.name}`,
                  value: item._id,
                };
              },
              col: 24,
            }
          : null,
        id !== "new"
          ? {
              label: t("InterpreteDetail.accessAuthorized"),
              name: "status",
              value: status,
              required: true,
              visible: userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              type: "select",
              selectContent: [
                { label: t("InterpreteDetail.yes"), value: "active" },
                { label: t("InterpreteDetail.no"), value: "inactive" },
              ],
              col: 24,
            }
          : null,
      ],
    },
    {
      children: [
        {
          label:
            id === "new"
              ? t("InterpreteDetail.createInterprete")
              : t("InterpreteDetail.save"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = async data => {
    if (id === "new") {
      data.role = roles.interprete;
    }

    await dispatch(setPropertiesInterprete(data));
    dispatch(updateInterprete());
  };

  const sendEmail = async () => {
    let caller = await http.post("/notifications/invitation", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: t("InterpreteDetail.emailSentSuccessfully"),
      });
  };

  return (
    <>
      <Typography.Title level={3} className={""}>
        {id === user._id
          ? t("InterpreteDetail.myInterpreteAccount")
          : routes.interpretes(id).detail.title}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <ActionDropdown
            rule={{
              only: {
                [roles.admin]: "crud",
                [roles.permanance]: "crud",
              },
            }}
          >
            <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
              <a onClick={sendEmail}>
                <span style={{ marginLeft: 5, marginRight: 10 }}>
                  <RiMailSendLine size={18} />
                </span>
                {t("InterpreteDetail.sendInvitationEmail")}
              </a>
            </ActionRoleSpecific>
          </ActionDropdown>

          <CustomForm
            disabled={
              !userHasLevel({
                only: {
                  [roles.admin]: "crud", //
                  [roles.permanance]: "crud", //
                },
              })
            }
            initialValues={interprete}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
